<div class="collection-card" [routerLink]="root.collection(collection.id)">
    <div class="collection-card__image">
        <img [src]="collection.imageBanner" alt="">
    </div>
    <div class="collection-card__info text-center">
        <h6>{{collection.descrizione}}</h6>
        <span>{{collection.descrizioneAggiuntiva}}</span>
    </div>
</div>
